<template>
	<div class="action-tabs">
		<Tab
			v-if="!isMobileViewport"
			icon-size="lg"
			class="desktop-nav"
			:active-tab="activeTab"
			:tabs="tabs"
			:is-change-disabled="markingIsActive"
			@tab-change="handleTabChange"
		>
			<!-- tag buttons -->
			<template #tab-details-tag-buttons>
				<TagCenter />
			</template>
			<!-- tag list -->
			<template #tab-details-tags>
				<TagListBlock />
			</template>
			<!-- clips -->
			<template #tab-details-clips>
				<ClipListBlock />
			</template>
			<!-- athletes -->
			<template
				v-if="isPlayerCompetition"
				#tab-details-athletes
			>
				<AthletesBlock />
			</template>
			<!-- settings -->
			<template #tab-details-settings>
				{{ trans('commons.settings') }}
			</template>
		</Tab>
		<NavigationMenuMobile
			v-if="isMobileViewport"
			:tabs="tabs"
			:active-tab="activeTab"
			@tab-change="handleTabChange"
		>
			<!-- tag buttons -->
			<template #tab-details-tag-buttons>
				<TagCenter />
			</template>
			<!-- tag list -->
			<template #tab-details-tags>
				<TagListBlock />
			</template>
			<!-- clips -->
			<template #tab-details-clips>
				<ClipListBlock />
			</template>
			<!-- settings -->
			<template #tab-details-settings>
				<SettingsPageMobile />
			</template>
		</NavigationMenuMobile>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

import Tab from '@components/tab';
import NavigationMenuMobile from '@components/navigation-menu-mobile';
import TagCenter from '@videotools/js/analysis/components/TagCenter/TagCenter';

import TagListBlock from '@js/analysis/blocks/TagList.vue';
import AthletesBlock from '@js/analysis/blocks/Athletes.vue';
import ClipListBlock from '@js/blocks/ClipList.vue';

import { bus } from '@videotools/js/events';
import SettingsPageMobile from '@videotools/js/analysis/pages/SettingsPageMobile';
import { events as HOTKEYS_EVENTS } from '@videotools/js/events/modules/player-hotkeys';

const events = [
	HOTKEYS_EVENTS.HOTKEY_NEXT_TAB,
	HOTKEYS_EVENTS.HOTKEY_PREVIOUS_TAB,
];

export default {
	name:       'ActionTabs',
	components: {
		SettingsPageMobile,
		Tab,
		TagCenter,
		TagListBlock,
		ClipListBlock,
		NavigationMenuMobile,
		AthletesBlock,
	},
	data() {
		return {
			activeTab: null,
			prevTab:   null,
		};
	},
	computed: {
		// tabs
		tabs() {
			const tabs = [
				{
					key:  'tags',
					icon: 'bullet-list',
				},
				{
					key:  'clips',
					icon: 'video-playlist',
				},
			];
			if (this.isNarrowAnalysis) {
				tabs.unshift({
					key:  'tag-buttons',
					icon: 'tag-general_tagging',
				});
			}
			if (this.isMobileViewport) {
				tabs.push({
					key:  'settings',
					icon: 'settings-gear',
				});
			}
			return tabs;
		},
		...mapGetters({
			isPlayerCompetition: 'event/isPlayerCompetition',
			isMobileViewport:    'device/isMobileViewport',
			isNarrowAnalysis:    'device/isNarrowAnalysis',
			event:               'event/event',
			markingIsActive:     'markingZone/active',
		}),
	},
	watch: {
		isNarrowAnalysis() {
			this.$nextTick(() => {
				this.activeTab = this.tabs[0].key;
			});
		},
	},
	mounted() {
		for (const event of events) {
			bus.subscribe(event, this[`BUS-${event}`]);
		}
	},
	destroyed() {
		for (const event of events) {
			bus.unsubscribe(event, this[`BUS-${event}`]);
		}
	},
	methods: {
		handleTabChange(tabKey) {
			this.prevTab = this.activeTab;
			this.activeTab = tabKey;
		},
		[`BUS-${HOTKEYS_EVENTS.HOTKEY_NEXT_TAB}`]() {
			const tabIndex = this.tabs.findIndex(tab => tab.key === this.activeTab);

			let newTab;
			if (tabIndex === this.tabs.length - 1) newTab = this.tabs[0];
			else newTab = this.tabs[tabIndex + 1];

			this.activeTab = newTab.key;
		},
		[`BUS-${HOTKEYS_EVENTS.HOTKEY_PREVIOUS_TAB}`]() {
			const tabIndex = this.tabs.findIndex(tab => tab.key === this.activeTab);

			let newTab;
			if (tabIndex === 0) newTab = this.tabs[this.tabs.length - 1];
			else newTab = this.tabs[tabIndex - 1];

			this.activeTab = newTab.key;
		},
	},
};
</script>

<style lang="scss" scoped>
.action-tabs {
	width: 100%;
	height: 100%;
}
</style>
